/* eslint-disable react-hooks/exhaustive-deps */
import Chart from 'react-google-charts';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import {
  Container,
  Content,
  DetalhesNegocioContainer,
  GraficoBoletoContainer,
  GraficoInfoContainer,
  GraficosContainer,
  QuantidadeParcelasContainer,
  TipoNegocio,
  TipoNegocioContainer,
  TipoNegocioData,
  TituloGrafico,
} from './styles';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useNegocioContext } from '../../context/context/DetalhamentoNegocioContext';
import { useHeaderFilter } from '../../hooks/hooks/useHeaderFilter';
import { useLoading } from '../../hooks/useLoading';
import { useUser } from '../../hooks/useUser';
import { Loader } from '../Loader/Loader';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

interface DetalhamentoNegocioProps {
  account: string;
  appAcesso: string;
}

export function DetalhamentoNegocio({
  account,
  appAcesso,
}: DetalhamentoNegocioProps) {
  let id_app_acesso: number | undefined = undefined;
  if (appAcesso === 'Whatsapp') {
    id_app_acesso = 2;
  } else if (appAcesso === 'Portal') {
    id_app_acesso = 1;
  }
  const navigate = useNavigate();

  const { negocio, getNegocio } = useNegocioContext();
  const { currentCompany } = useUser();
  const { dataFim, dataInicio, filtrado, chamado } = useHeaderFilter();
  const { showLoader, hideLoader, loader } = useLoading();

  useEffect(() => {
    showLoader();
    getNegocio(
      dataInicio,
      dataFim,
      String(currentCompany.credor_infos.credor_crm),
      id_app_acesso,
    );
    hideLoader();
  }, [currentCompany]);

  useEffect(() => {
    showLoader();
  }, [filtrado, chamado]);

  function goToBoletos() {
    navigate('/boletos');
  }

  return (
    <Container>
      {loader && <Loader />}
      <Content>
        <DetalhesNegocioContainer>
          <QuantidadeParcelasContainer>
            <TituloGrafico>Quantidade de parcelas</TituloGrafico>
            <Bar
              data={{
                labels: negocio?.parcelas?.map((parcela) => parcela.label),
                datasets: [
                  {
                    label: 'Quantidade',
                    data: negocio?.parcelas?.map((parcela) => parcela.value),
                    backgroundColor: ['#0A78CB'],
                    borderRadius: 4,
                    maxBarThickness: 35,
                  },
                ],
              }}
              width={300}
              height={320}
              options={{
                indexAxis: 'y',

                scales: {
                  x: {
                    grid: {
                      display: true,
                      borderWidth: 0,
                      color: '#C4C4C4',
                    },
                  },
                  y: {
                    grid: {
                      display: false,
                      borderWidth: 2,
                      color: '#3B3B3B',
                      borderColor: '#3B3B3B',
                    },
                    beginAtZero: true,
                  },
                },

                plugins: {
                  legend: {
                    display: false,
                  },
                },
              }}
            />
          </QuantidadeParcelasContainer>

          <GraficoInfoContainer>
            <GraficosContainer>
              <GraficoBoletoContainer>
                <TituloGrafico onClick={goToBoletos} isBoletos>
                  Canal envio de boletos
                </TituloGrafico>
                <div className="chart">
                  <Chart
                    chartType="PieChart"
                    data={[
                      ['Metodo', 'Quantidade'],
                      ['WhatsApp', negocio?.negocio?.canalEnvio.whatsapp],
                      ['E-mail', negocio?.negocio?.canalEnvio.email],
                      ['SMS', negocio?.negocio?.canalEnvio.sms],
                      ['Cod. Barra', negocio?.negocio?.canalEnvio.codBarras],
                      ['Download', negocio?.negocio?.canalEnvio.download],
                    ]}
                    options={{
                      width: window.innerWidth <= 1024 ? 300 : 500,
                      height: 230,
                      pieHole: 0.4,
                      backgroundColor: 'transparent',
                      colors: [
                        '#0A78CB',
                        '#2299F3',
                        '#0C82DC',
                        '#15DFF5',
                        '#3EE7FA',
                      ],
                      legend: {
                        position: 'right',
                        alignment: 'center',
                        textStyle: {
                          fontSize: 16,
                          fontName: 'Roboto',
                          color: '#3B3B3B',
                        },
                      },
                      pieSliceText: 'percentagem',
                      pieSliceTextStyle: {
                        fontSize: 14,
                        fontName: 'Roboto',
                        color: '#fff',
                        fontWeight: '500',
                      },
                    }}
                  />
                </div>
              </GraficoBoletoContainer>
              <GraficoBoletoContainer>
                <TituloGrafico>Confirmação de recebimento</TituloGrafico>

                <div>
                  <Bar
                    data={{
                      labels: [''],
                      datasets: [
                        {
                          label: 'Acordos',
                          data: [negocio?.negocio?.recebimento.acordos],
                          backgroundColor: ['#15DFF5'],
                          maxBarThickness: 26,
                          borderRadius: 4,
                        },
                        {
                          label: 'Enviados',
                          data: [negocio?.negocio?.recebimento.enviados],
                          backgroundColor: ['#0C82DC'],
                          maxBarThickness: 26,
                          borderRadius: 4,
                        },
                        {
                          label: 'Confirmação de entrega',
                          data: [negocio?.negocio?.recebimento.confEntrega],
                          backgroundColor: ['#0A78CB'],
                          maxBarThickness: 26,
                          borderRadius: 4,
                        },
                        {
                          label: 'Confirmação do cliente',
                          data: [negocio?.negocio?.recebimento.confCliente],
                          backgroundColor: ['#2299F3'],
                          maxBarThickness: 26,
                          borderRadius: 4,
                        },
                      ],
                    }}
                    width={450}
                    height={230}
                    options={{
                      scales: {
                        x: {
                          stackWeight: 0.7,
                          grid: {
                            display: false,
                          },
                        },
                        y: {
                          max: 100,
                          grid: {
                            display: false,
                          },
                          beginAtZero: true,
                        },
                      },

                      plugins: {
                        legend: {
                          position: 'right' as const,
                          display: true,
                          maxWidth: 200,
                          maxHeight: 100,
                          labels: {
                            boxWidth: 10,
                            boxHeight: 10,
                            usePointStyle: true,
                            font: {
                              size: 14,
                              family: 'Roboto',
                            },
                          },
                        },
                      },
                    }}
                  />
                </div>
              </GraficoBoletoContainer>
            </GraficosContainer>
            {window.innerWidth > 1366 && (
              <TipoNegocioContainer>
                <TituloGrafico>Tipo de negócio</TituloGrafico>

                <TipoNegocioData>
                  <TipoNegocio>
                    <p>AV</p>
                    <h2>
                      {' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        negocio?.negocio?.tipoNegocio.av
                          ? negocio?.negocio?.tipoNegocio.av
                          : 0,
                      )}
                    </h2>
                  </TipoNegocio>

                  <TipoNegocio>
                    <p>ENTRADA</p>
                    <h2>
                      {' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        negocio?.negocio?.tipoNegocio.entrada
                          ? negocio?.negocio?.tipoNegocio.entrada
                          : 0,
                      )}
                    </h2>
                  </TipoNegocio>
                  <TipoNegocio>
                    <p>AV + ENTR</p>
                    <h2>
                      {' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        negocio?.negocio?.tipoNegocio.avEntrada
                          ? negocio?.negocio?.tipoNegocio.avEntrada
                          : 0,
                      )}
                    </h2>
                  </TipoNegocio>
                  <TipoNegocio>
                    <p>DEMAIS PARCELAS</p>
                    <h2>
                      {' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        negocio?.negocio?.tipoNegocio.parcelas
                          ? negocio?.negocio?.tipoNegocio.parcelas
                          : 0,
                      )}
                    </h2>
                  </TipoNegocio>
                  <TipoNegocio>
                    <p>TOTAL</p>
                    <h2>
                      {' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(
                        negocio?.negocio?.tipoNegocio.total
                          ? negocio?.negocio?.tipoNegocio.total
                          : 0,
                      )}
                    </h2>
                  </TipoNegocio>
                </TipoNegocioData>
              </TipoNegocioContainer>
            )}
          </GraficoInfoContainer>
        </DetalhesNegocioContainer>
        {window.innerWidth <= 1366 && (
          <TipoNegocioContainer>
            <TituloGrafico>Tipo de negócio</TituloGrafico>

            <TipoNegocioData>
              <TipoNegocio>
                <p>AV</p>
                <h2>
                  {' '}
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(
                    negocio?.negocio?.tipoNegocio.av
                      ? negocio?.negocio?.tipoNegocio.av
                      : 0,
                  )}
                </h2>
              </TipoNegocio>

              <TipoNegocio>
                <p>ENTRADA</p>
                <h2>
                  {' '}
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(
                    negocio?.negocio?.tipoNegocio.entrada
                      ? negocio?.negocio?.tipoNegocio.entrada
                      : 0,
                  )}
                </h2>
              </TipoNegocio>
              <TipoNegocio>
                <p>AV + ENTR</p>
                <h2>
                  {' '}
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(
                    negocio?.negocio?.tipoNegocio.avEntrada
                      ? negocio?.negocio?.tipoNegocio.avEntrada
                      : 0,
                  )}
                </h2>
              </TipoNegocio>
              <TipoNegocio>
                <p>DEMAIS PARCELAS</p>
                <h2>
                  {' '}
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(
                    negocio?.negocio?.tipoNegocio.parcelas
                      ? negocio?.negocio?.tipoNegocio.parcelas
                      : 0,
                  )}
                </h2>
              </TipoNegocio>
              <TipoNegocio>
                <p>TOTAL</p>
                <h2>
                  {' '}
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(
                    negocio?.negocio?.tipoNegocio.total
                      ? negocio?.negocio?.tipoNegocio.total
                      : 0,
                  )}
                </h2>
              </TipoNegocio>
            </TipoNegocioData>
          </TipoNegocioContainer>
        )}
      </Content>
    </Container>
  );
}
